import {findPeriodOfDate} from 'common/utils/dateUtils/date-utils';
import {AvailableDay} from 'common/domain/models/availableDayTypes';
import {Request} from 'common/domain/models/request';
import Swipe from 'common/utils/swipe';
import PeriodActionsHelper from 'vacations-absences.module/common/helpers/periodActions.helpers';

class PeriodCardController {
  constructor($scope, $timeout, EventEmitter) {
    'ngInject';
    this.scope = $scope;
    this.isHover = false;
    this.timeout = $timeout;
    this.eventEmitter = EventEmitter;
  }

  $onInit() {
    this.type = Request.getTranslation(this.period.type);
    this.category = this.period.category;
    this.availableDayType = AvailableDay.getTranslation(this.period.availableDayType);
    this.status = this.period.status;
    this.code = this.period.code;
    this.maximumDuration = this.period.maximumDuration || this.period.duration;
  }

  $postLink() {
    if (this.readOnly) {
      return;
    }

    if (this.isMobileApp) {
      this.periodActionsHelper = new PeriodActionsHelper(this.period, this.isInception);

      if (this.periodActionsHelper.available()) {
        this.timeout(() => {
          this.numberOfSwipeButtons = this.getNumberOfSwipeButtons();
          this.initSwipe();
        });
      }

    } else {
      this.initHoverListener();
    }
  }

  initSwipe() {
    const swiper = new Swipe(this.getPeriodCardIdSelector());
    swiper.onLeft(event => this.onSwipeLeft(event));
    swiper.onRight(event => this.onSwipeRight(event));
    swiper.run();
  }

  getPeriodCardIdSelector() {
    return `period-card .${this.cardId}`;
  }

  onSwipeRight() {
    this.timeout(() => {
      this.swiped = false;
    });
  }

  onSwipeLeft() {
    this.timeout(() => {
      this.swiped = true;
    });

  }

  getNumberOfSwipeButtons() {
    let numberOfSwipeButtons = 0;

    if (this.periodActionsHelper.canInsertAbsence()) {
      numberOfSwipeButtons++;
    }

    if (this.periodActionsHelper.periodCanBeRemoved()) {
      numberOfSwipeButtons++;
    }

    if (this.periodActionsHelper.periodCanBeEdited()) {
      numberOfSwipeButtons++;
    }

    return numberOfSwipeButtons;
  }

  initHoverListener() {
    this.scope.$on('period-hover-in', (event, args) => {
      if (findPeriodOfDate(args.date, this.period.startDate, this.period.endDate)) {
        this.isHover = true;
        this.scope.$apply();
      }
    });

    this.scope.$on('period-hover-out', () => {
      this.isHover = false;
      this.scope.$apply();
    });
  }

  isRequested() {
    return this.status === Request.STATUS.REQUESTED;
  }

  isSickPedingLeave(){
    const posibleSicks = ['ENF', 'ACC', 'ANL'];
    const sick = posibleSicks.includes(this.code);

    return sick && this.status === Request.STATUS.REQUESTED;
  }

  isDeleted() {
    return this.status === Request.STATUS.DELETED;
  }

  getCssClasses() {
    let classes = [this.period.type];

    if (this.isHover) {
      classes.push('hover');
    }

    if (this.isMobileApp) {
      classes.push('responsiveMobile');
    }

    if (this.renderRemarks()) {
      classes.push('remarks');
    }

    if (this.swiped) {
      classes.push('swiped');

      if (this.numberOfSwipeButtons === 1) {
        classes.push('swiped-one-button');
      }
    }

    return classes;
  }

  getMobileButtonsContainerClasses() {
    let classes = [];

    if (this.numberOfSwipeButtons === 1) {
      classes.push('one-button');
    }

    return classes;
  }

  removePeriod() {
    this.swiped = false;
    this.onRemovePeriod(this.eventEmitter({period: this.period}));
  }

  editPeriod() {
    this.swiped = false;

    this.onEditPeriod(this.eventEmitter({period: this.period}));
  }

  addPeriod() {
    this.swiped = false;
    this.onAddPeriod(this.eventEmitter({startDate: this.period.startDate}));
  }

  renderRemarks() {
    return this.period.remarks && this.isTeamCalendarMobile;
  }
}

export default PeriodCardController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCard.controller.js